import(/* webpackMode: "eager" */ "/app/app/(providers)/orthopedic-surgery-detailpage/page.js");
